import { Outlet } from 'react-router-dom';
import { Header } from '../feature/Header';
import { Footer } from '../feature/Footer';

export function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
